module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Choose the next president")]), _c('player-selector', {
    attrs: {
      "filter": _vm.filter
    },
    model: {
      value: (_vm.target),
      callback: function($$v) {
        _vm.target = $$v
      },
      expression: "target"
    }
  }), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.target
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Nominate")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23d52d29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/game-states/EXECUTIVE_ACTION/actions/special-election.vue
// module id = 314
// module chunks = 0